import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';

import { featuredTestimonialResourceDefinition } from '../utils/queryDefinitions';

export default function useFeaturedTestimonial({ breederProfileId, enabled }) {
  const {
    value: { featured_testimonial: featuredTestimonial },
    isSuccess
  } = useResourceQuery({
    ...featuredTestimonialResourceDefinition(breederProfileId),
    enabled: Boolean(enabled && breederProfileId)
  });

  return {
    featuredTestimonial: featuredTestimonial || null,
    isLoaded: isSuccess
  };
}
